import Button from '@salesforce/design-system-react/components/button';
import Icon from '@salesforce/design-system-react/components/icon';
import ProgressBar from '@salesforce/design-system-react/components/progress-bar';
import classNames from 'classnames';
import { FactoryEmaillabApiV1Project } from '../../app/apiGenerated';
import { formatPeriod } from '../../components/JSONSchemaForm/theme/fields/PeriodSelectorField';
import { GoogleColorToHex } from '../../components/Badges/Badges';

const ProjectsList = ({
  projects,
  onClick,
  onClickEdit,
  onClickDelete
}: {
  projects?: FactoryEmaillabApiV1Project[];
  onClick?: (project: FactoryEmaillabApiV1Project | undefined) => void;
  onClickEdit?: (project: FactoryEmaillabApiV1Project | undefined) => void;
  onClickDelete?: (project: FactoryEmaillabApiV1Project | undefined) => void;
}) => {
  return (
    <div
      className="slds-grid slds-wrap slds-p-around_medium slds-gutters slds-m-left_none slds-grid_vertical-align-start"
      style={{ flexGrow: '1', overflowY: 'auto' }}
    >
      {projects?.map((e) => {
        return (
          <div className="slds-m-bottom_large slds-m-right_medium">
            <ProjectObjectDetails
              item={e}
              onClickEdit={onClickEdit}
              onClick={onClick}
              onClickDelete={onClickDelete}
              width="20rem"
            />
          </div>
        );
      })}
    </div>
  );
};

export const ProjectObjectDetails = ({
  item,
  onClickEdit,
  onClose,
  onClickDelete,
  onClick,
  onMouseEnter,
  onMouseLeave,
  noBorder = false,
  width = '40rem',
  actions
}: {
  item: FactoryEmaillabApiV1Project | undefined;
  onClickEdit?: (project: FactoryEmaillabApiV1Project | undefined) => void;
  onClick?: (project: FactoryEmaillabApiV1Project | undefined) => void;
  onClose?: (project: FactoryEmaillabApiV1Project | undefined) => void;
  onClickDelete?: (project: FactoryEmaillabApiV1Project | undefined) => void;
  noBorder?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  width?: string;
  actions?: React.ReactNode;
}) => {
  const projectColor = GoogleColorToHex({
    color: item?.color,
    defaultValue: { r: 240, g: 241, b: 243 }
  });

  return (
    <section
      aria-labelledby="panel-heading-id"
      className={classNames(
        'slds-popover_panel slds-p-around_none overflow-hidden slds-grid slds-grid_vertical',
        {
          'slds-box': !noBorder
        }
      )}
      style={{
        background: '#fff',
        width: width,
        borderTop: '7px solid ' + projectColor,
        height: '9rem',
        cursor: 'pointer'
      }}
      role="dialog"
      onMouseUp={() => onClick?.(item)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="slds-p-horizontal_medium slds-p-vertical_medium slds-grid">
        <div className="flex-grow-1">
          <dt className="">
            <div className="slds-media slds-media_center">
              {/* <div
                className="slds-media__figure"
                style={{ alignSelf: 'flex-start' }}
              >
                <Icon
                  category="utility"
                  name="archive"
                  size="small"
                  style={{ opacity: 0.3 }}
                />
              </div> */}
              <div className="slds-media__body">
                <p className="slds-text-heading_small slds-hyphenate">
                  <strong>{item?.display_name}</strong>
                </p>
                {/* <p
                  className="slds-text-body_small slds-m-bottom_x-small"
                  style={{ whiteSpace: 'pre-wrap', userSelect: 'all' }}
                >
                  {item?.description?.short_version || (
                    <span style={{ opacity: 0.5 }}>No Description</span>
                  )}
                </p>
                <div className="slds-p-bottom_small">
                  <div className="slds-grid slds-grid_align-spread">
                    <span>
                      <span className="slds-m-right_xx-small">
                        <strong>
                          {item?.measurement?.type === 'PERCENT'
                            ? item?.measurement?.current_value + '%'
                            : item?.measurement?.type === 'CURRENCY'
                            ? (item?.measurement?.currency_code || '') +
                              item?.measurement?.current_value
                            : item?.measurement?.current_value}
                        </strong>
                      </span>
                    </span>

                    <span>
                      {item?.measurement?.type === 'PERCENT'
                        ? item?.measurement?.target_value + '%'
                        : item?.measurement?.type === 'CURRENCY'
                        ? (item?.measurement?.currency_code || '') +
                          item?.measurement?.target_value
                        : item?.measurement?.target_value}
                    </span>
                  </div>
                  <ProgressBar
                    value={Math.min(
                      (parseInt(item?.measurement?.current_value || '0') *
                        100) /
                        parseInt(item?.measurement?.target_value || '1') || 0,
                      100
                    )}
                    radius="circular"
                    thickness="medium"
                  />
                </div>
                <div className="slds-text-align_right">
                  {formatPeriod(
                    item?.period?.term,
                    item?.period?.fiscal_year
                  ) || <span style={{ opacity: 0.5 }}>No Period</span>}
                </div> */}
              </div>
            </div>
          </dt>
        </div>
        <div
          style={{
            flex: 'none'
          }}
          className="slds-p-left_x-small"
        >
          <>
            {onClickDelete !== undefined && (
              <Button
                iconCategory="utility"
                iconName="delete"
                iconVariant="bare"
                variant="icon"
                onClick={() => onClickDelete?.(item)}
              />
            )}
            {onClickEdit !== undefined && (
              <Button
                iconCategory="utility"
                iconName="edit"
                iconVariant="bare"
                variant="icon"
                onClick={() => onClickEdit?.(item)}
              />
            )}
            {onClose !== undefined && (
              <Button
                iconCategory="utility"
                iconName="close"
                iconVariant="bare"
                variant="icon"
                iconSize="large"
                onClick={() => {
                  onClose?.(item);
                }}
              />
            )}
            {actions !== undefined && actions}
          </>
        </div>
      </div>
    </section>
  );
};
export default ProjectsList;
